import { create } from 'zustand';

export interface AssociationInfo {
  name: string;
  symbol: string;
  email: string;
  /** Numeric association id (verbandid) - the reliable way to gate per-association behaviour. */
  verbandId?: number;
  /** Set by the backend for associations that require a Spielgemeinschaft club name. */
  requiresSpielgemeinschaftClub?: boolean;
}

interface AssociationState {
  association: AssociationInfo | null;
  setAssociation: (info: AssociationInfo) => void;
  clearAssociation: () => void;
}

export const useAssociationStore = create<AssociationState>((set) => ({
  association: null,
  setAssociation: (info) => set({ association: info }),
  clearAssociation: () => set({ association: null }),
}));
